import { defineStore } from "pinia";

export const useRoutesStore = defineStore("routes", {
    state: () => ({
        routes: {},
    }),
    getters: {
        routeParams(state) {
            return (routeName) => {
                return state.routes[routeName]?.params;
            };
        },
    },
    actions: {
        initialize(router) {
            for (const x of router.getRoutes()) {
                this.routes[x.name] = {
                    path: x.path,
                    meta: x.meta,
                    params: x.path
                        .split("/")
                        .filter((segment) => segment.charAt(0) === ":")
                        .map((param) => param.substring(1)),
                };
            }
        },
    },
});
